<template>
    <div class="col-md-12">
        <table-search-and-pagination
            :table-data="customers"
            @dataUpdated="queriedData = $event"
        >
            <customers-table v-if="customers.length" :customers="queriedData" />
        </table-search-and-pagination>
    </div>
</template>

<script>
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import CustomersTable from "./CustomersTable.vue";

export default {
    name: "Customers",
    components: {
        TableSearchAndPagination,
        CustomersTable,
    },
    props: {
        customers: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            queriedData: [],
        };
    },
};
</script>
